import type { ApiAnswerDetail } from '../../../../internalTypes';

export function extractHintLabels(
  answerDetails: ApiAnswerDetail[] = [],
  language?: string
): { minLabel?: string; midLabel?: string; maxLabel?: string } {
  const hints = answerDetails
    .filter(a => a.additional?.isHintText && !a.hidden)
    .map(a => (language && a.translations?.[language]?.answerText) || a.answerText || '')
    .filter(Boolean);

  if (hints.length >= 3) {
    return { minLabel: hints[0], midLabel: hints[1], maxLabel: hints[2] };
  }
  return { minLabel: hints[0], maxLabel: hints[1] };
}
